import { TSvgIcon } from '../types';

export const ExclamationIcon: TSvgIcon = ({ color = '#A9ADBC', width = 20, height = 20 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                id="Vector"
                d="M8.16699 4.83341H9.83366V6.50008H8.16699V4.83341ZM8.16699 8.16675H9.83366V13.1667H8.16699V8.16675ZM9.00033 0.666748C4.40033 0.666748 0.666992 4.40008 0.666992 9.00008C0.666992 13.6001 4.40033 17.3334 9.00033 17.3334C13.6003 17.3334 17.3337 13.6001 17.3337 9.00008C17.3337 4.40008 13.6003 0.666748 9.00033 0.666748ZM9.00033 15.6667C5.32533 15.6667 2.33366 12.6751 2.33366 9.00008C2.33366 5.32508 5.32533 2.33341 9.00033 2.33341C12.6753 2.33341 15.667 5.32508 15.667 9.00008C15.667 12.6751 12.6753 15.6667 9.00033 15.6667Z"
                fill={color}
            />
        </svg>
    );
};
